import { render, staticRenderFns } from "./couponDetailManageList.vue?vue&type=template&id=6509f0fe&scoped=true"
import script from "./couponDetailManageList.vue?vue&type=script&lang=js"
export * from "./couponDetailManageList.vue?vue&type=script&lang=js"
import style0 from "./couponDetailManageList.vue?vue&type=style&index=0&id=6509f0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6509f0fe",
  null
  
)

export default component.exports